<template>
  <v-layout
    column
    wrap
    v-if="installmentsGroups && installmentsGroups.length >= 0"
  >
    <template v-for="(group, index) in installmentsGroups">
      <v-flex ml-2 mr-2 mt-2 mb-2 v-if="group.id" :key="index">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">
                {{ group.total_amount | formatCurrency }}
                <v-chip small label color="blue" text-color="white">
                  {{ group.charge_type | formatChargeType }}
                </v-chip>
                <v-chip
                  v-if="group.status === 'paid'"
                  small
                  label
                  color="green"
                  text-color="white"
                >
                  Pago
                </v-chip>
                <v-chip
                  v-if="group.status === 'canceled'"
                  small
                  label
                  color="red"
                  text-color="white"
                >
                  Cancelado
                </v-chip>
                <v-chip
                  small
                  label
                  color="teal"
                  text-color="white"
                  v-if="group.is_cancellation_charge"
                >
                  Fatura de Débitos - Parcelamento Automático
                </v-chip>
                <v-tooltip bottom v-if="group.status === 'refused'">
                  <template v-slot:activator="{ on }">
                    <v-chip
                      small
                      label
                      color="red"
                      text-color="white"
                      v-on="on"
                    >
                      Recusado
                    </v-chip>
                  </template>
                  <span v-if="group.debt_billing_transaction_message">{{
                    group.debt_billing_transaction_message
                  }}</span>
                  <span v-else>Recusado</span>
                </v-tooltip>
                <v-chip
                  v-if="group.status === 'payment_error'"
                  small
                  label
                  color="red"
                  text-color="white"
                >
                  Erro
                </v-chip>
              </div>
              <span class="grey--text">
                {{ group.num_installments }}
                {{ group.num_installments > 1 ? "parcelas" : "parcela" }} de
                originalmente
                {{
                  (group.total_amount / group.num_installments) | formatCurrency
                }}
              </span>
              <v-spacer />
              <span
                v-if="group.parceled_by"
                ml-4
                mr-4
                class="caption grey--text"
                >Parcelado por {{ group.parceled_by }} em
                {{ group.created_at | formatarDate }}
              </span>
              <span
                v-if="group.canceled_by"
                ml-4
                mr-4
                class="caption grey--text"
                ><br />Cancelado por {{ group.canceled_by }} em
                {{ group.canceled_at | formatarDate }}
              </span>
            </div>
            <v-flex
              v-if="
                group.charge_type === 'debt_billing' &&
                group.status !== 'paid' &&
                isAdmin
              "
              sm12
              xs12
              md12
            >
              <v-btn
                color="tertiary"
                small
                v-if="group.status !== 'canceled'"
                @click="openReparcelDialog(null, group.id)"
                ><v-icon left>date_range</v-icon>Alterar Parcelamento</v-btn
              >
            </v-flex>
            <v-flex
              v-if="
                group.charge_type !== 'credit_billing' &&
                group.status !== 'paid' &&
                isAdmin
              "
              sm12
              xs12
              md12
            >
              <v-btn
                v-if="group.status !== 'canceled'"
                color="red"
                small
                @click="openCancellationDialog(group)"
                ><v-icon left>delete</v-icon>Cancelar Acordo</v-btn
              >
            </v-flex>
            <v-flex
              v-if="
                group.charge_type === 'credit_billing' &&
                (group.status === 'payment_error' ||
                  group.status === 'refused') &&
                isAdmin
              "
              sm12
              xs12
              md12
            >
              <v-btn color="red" small @click="openCancellationDialog(group)"
                ><v-icon left>delete</v-icon>Cancelar Acordo</v-btn
              >
            </v-flex>
            <v-flex
              v-if="
                group.charge_type === 'credit_billing' &&
                (group.status === 'payment_error' || group.status === 'refused')
              "
              sm12
              xs12
              md12
            >
              <v-btn
                color="tertiary"
                small
                @click="openReprocessingDialog(group)"
                ><v-icon left>cached</v-icon>Reprocessar Acordo</v-btn
              >
            </v-flex>
          </v-card-title>
          <v-card-actions v-if="group.charge_type !== 'credit_billing'">
            Parcelas
            <v-spacer></v-spacer>
            <v-btn icon @click="toggleParcelsVisibity(index)">
              <v-icon :color="group.showParcels ? 'tertiary' : 'primary'">
                {{
                  group.showParcels
                    ? "keyboard_arrow_up"
                    : "keyboard_arrow_down"
                }}
              </v-icon>
            </v-btn>
          </v-card-actions>
          <v-list subheader v-if="group.showParcels && group.installments">
            <v-list-tile
              v-for="(item, index) in group.installments"
              :key="item"
              avatar
            >
              <v-list-tile-avatar
                :color="getInstallmentColor(index, group)"
                size="24"
              >
                {{ index + 1 }}
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  {{ getInstallmentStatus(index, group) }}
                  <span
                    v-if="
                      group.charge_type == 'debt_billing' &&
                      getInstallmentStatus(index, group) === 'Paga'
                    "
                    class="green--text caption"
                  >
                    ⋅
                    {{
                      getDebtBillingPaidDate(group.charged_debt_billings[index])
                        | formatDate
                    }}
                  </span>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <span v-if="group.charge_type === 'debt_billing'">{{
                    getDebtBillingTotal(group.charged_debt_billings[index])
                      | formatCurrency
                  }}</span>
                  <span v-else>{{
                    (group.total_amount / group.num_installments)
                      | formatCurrency
                  }}</span>
                  <span
                    v-if="group.charge_type == 'debt_billing'"
                    :class="[
                      getInstallmentStatus(index, group) !== 'Paga' &&
                      beforeToday(
                        getDebtBillingDueDate(
                          group.charged_debt_billings[index],
                        ),
                      )
                        ? 'red--text caption'
                        : 'caption',
                    ]"
                  >
                    ⋅ Vencimento:
                    {{
                      getDebtBillingDueDate(group.charged_debt_billings[index])
                        | formatDate
                    }}
                  </span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action
                v-if="
                  group.charge_type == 'debt_billing' &&
                  group.charged_debt_billings[index]
                "
              >
                <v-layout>
                  <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon v-on="on" block color="tertiary" small>
                        <v-icon right>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        @click.prevent="
                          openBillet(group.charged_debt_billings[index])
                        "
                      >
                        <v-list-tile-action>
                          <v-icon left>open_in_new</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title
                          >Abrir
                          {{
                            group.payment_type === "pix"
                              ? "QR code pix"
                              : "boleto"
                          }}</v-list-tile-title
                        >
                      </v-list-tile>
                      <v-list-tile
                        @click.prevent="
                          openReparcelDialog(
                            group.charged_debt_billings[index],
                            null,
                          )
                        "
                        v-if="isAdmin"
                      >
                        <v-list-tile-action>
                          <v-icon left>event</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title
                          >Alterar vencimento</v-list-tile-title
                        >
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
              </v-list-tile-action>
              <v-list-tile-action
                v-if="
                  group.charge_type != 'debt_billing' &&
                  group.charged_billings[index]
                "
              >
                <v-chip
                  label
                  color="grey lighten-3"
                  @click.prevent="
                    gotoTransactionHistory(group.charged_billings[index])
                  "
                >
                  <span class="caption">Fatura</span>
                  <v-icon right>chevron_right</v-icon>
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            Faturas geradoras do parcelamento
            <v-spacer></v-spacer>
            <v-btn icon @click="toggleBillingsVisibity(index)">
              <v-icon :color="group.showBillings ? 'tertiary' : 'primary'">
                {{
                  group.showBillings
                    ? "keyboard_arrow_up"
                    : "keyboard_arrow_down"
                }}
              </v-icon>
            </v-btn>
          </v-card-actions>
          <v-list subheader v-if="group.showBillings">
            <v-list-tile
              v-for="item in group.parent_billings"
              :key="item"
              avatar
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  <span class="caption ml-2">{{ showData(item) }}</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </template>
    <v-dialog v-model="changeDueDateDialog" max-width="550px" persistent>
      <v-form ref="reparcel">
        <v-card class="pa-3">
          <v-card-title class="py-2">
            <div class="headline font-weight-bold mx-auto">
              Alterar vencimento
            </div>
          </v-card-title>
          <v-card-text class="py-2">
            <span v-if="reparcelDebtBillingId">
              Essa operação irá mudar a data de vencimento da parcela com data
              de vencimento atual em
              {{ getDebtBillingDueDate(reparcelDebtBillingId) | formatDate }}.
              Selecione a nova data de vencimento.
            </span>
            <span v-if="reparcelInstallmentGroupId">
              Essa operação irá mudar a data de vencimento de todas as parcelas.
              Selecione a nova data de vencimento da primeira parcela. As
              parcelas seguintes terão data de vencimento após 30 dias da
              precedente.
            </span>
            <v-layout row wrap>
              <v-dialog
                ref="dateDialog"
                v-model="modal"
                :return-value.sync="newDueDate"
                persistent
                lazy
                full-width
                width="450px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="newDueDate"
                    label="Nova Data de Vencimento"
                    prepend-icon="date_range"
                    readonly
                    v-on="on"
                    :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  dark
                  v-model="newDueDate"
                  scrollable
                  width="450px"
                  :min="new Date().toISOString()"
                  :max="installmentMaxDateChangeExpire"
                  :allowed-dates="allowedDates"
                  solo
                >
                  <v-btn flat color="primary" @click="modal = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.dateDialog.save(newDueDate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
              <v-btn
                color="primary"
                flat
                @click="simulate(reparcelDebtBillingId, newDueDate)"
                >Simular</v-btn
              >
            </v-layout>
            <span
              v-if="
                reparcelDebtBillingId &&
                newDueDate &&
                newInstallmentValue.length > 0
              "
              >A nova data de vencimento será em
              <span class="font-weight-bold"
                >{{ newDueDate | formatDate }} </span
              >no valor de
              <span class="font-weight-bold">{{ newInstallmentValue }}</span
              >.</span
            >
            <span v-if="reparcelInstallmentGroupId && newDueDate"
              >A primeira nova data de vencimento será em
              <span class="font-weight-bold">{{ newDueDate | formatDate }}</span
              >.</span
            >
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn color="primary" text @click="closeReparcelDialog"
                >Cancelar</v-btn
              >
              <v-btn
                color="pink darken-1"
                text
                @click="reparcel"
                :disabled="loadingChange"
                :loading="loadingChange"
                >Alterar</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showReprocessingDialog" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="pt-2 pb-4">
          <div class="headline font-weight-bold mx-auto">
            Deseja reprocessar o acordo?
          </div>
        </v-card-title>
        <v-card-text class="py-2">
          <div xs12 md12 class="dialog-container mx-4">
            <div v-if="usedCreditCard" class="card-image">
              <img height="40px" :src="iconBrand(usedCreditCard)" /> **** ****
              **** {{ usedCreditCard?.last_digits }} (Cartão utilizado)
            </div>
            <span class="mt-3"
              >Selecione um cartão para fazer o reprocessamento:</span
            >
            <v-select
              prepend-icon="credit_card"
              v-model="selectedCreditCard"
              :items="creditCardsData"
              no-data-text="Não há cartões cadastrados"
              label="Cartões"
              required
              solo
              class="reprocess-select"
            >
              <template v-slot:selection="{ item }">
                <img height="40px" :src="iconBrand(item)" /> **** **** ****
                {{ item?.last_digits }}
              </template>
              <template v-slot:item="{ item }">
                <img height="40px" :src="iconBrand(item)" /> **** **** ****
                {{ item?.last_digits }}
              </template>
            </v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="closeReprocessingDialog"
              >Fechar</v-btn
            >
            <v-btn color="pink darken-1" text @click="reprocessInstallmentGroup"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCancellationDialog" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <div class="headline font-weight-bold mx-auto">
            Deseja cancelar o acordo?
          </div>
        </v-card-title>
        <v-card-text class="pt-2 pb-3">
          <div xs12 md12 class="dialog-container mx-4">
            <p class="">
              As faturas geradoras do acordo ficarão com o status vencido.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="closeCreditCancellationDialog"
              >Fechar</v-btn
            >
            <v-btn color="pink darken-1" text @click="cancelInstallmentGroup"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.value"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
    </v-snackbar>
    <cpnDetalhesFatura />
  </v-layout>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import firestore from "../../../firebase/firestore";
import { calendarMixin } from "../../../mixin/calendarMixin";
import {
  cancel,
  reparcel,
  reparcelAll,
  simulateReparcel,
} from "../../../services/billing";
import { getCards } from "../../../services/support/cards";
import DetalhesFatura from "../../faturaDetails/DetalhesFatura";

export default {
  props: ["consumerUnit"],
  mixins: [calendarMixin],

  data() {
    return {
      loadingChange: false,
      showBillings: false,
      modal: false,
      changeDueDateDialog: false,
      reparcelType: "",
      reparcelDebtBillingId: "",
      newDueDate: "",
      reparcelInstallmentGroupId: "",
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
      newInstallmentValue: "",
      maxDateChangeExpire: "",
      installmentMaxDateChangeExpire: "",
      currentInstallmentGroup: null,
      showReprocessingDialog: false,
      showCancellationDialog: false,
      selectedCreditCard: null,
      usedCreditCard: null,
      creditCardsData: null,
    };
  },
  computed: {
    ...mapGetters("installment", [
      "installmentsGroups",
      "debtBillings",
      "loading",
    ]),
    ...mapGetters("cs", ["billings"]),
    ...mapState(["config"]),
    ...mapState("cs", ["userCS", "user"]),
    ...mapGetters("cs", ["cards"]),
    isAdmin: function () {
      if (this.user && this.user.group) {
        return this.user.group.includes("admin");
      }
      return false;
    },
  },
  async mounted() {
    let due_date = new Date();

    if (this.consumerUnit && this.consumerUnit.id) {
      await this.getInstallmentsGroupsByConsumerUnit(this.consumerUnit.id);
      await this.getDebtBillingsByConsumerUnit(this.consumerUnit.id);
    }

    if (!this.billings || this.billings.length <= 0) {
      this.getBillings(this.consumerUnit);
    }

    if (this.isAdmin || this.isFinacial) {
      const config_date = (
        await firestore.collection("config").doc("segunda_via").get()
      ).data().max_days_admin;
      this.maxDateChangeExpire = config_date ?? 60;
      this.installmentMaxDateChangeExpire = defineMaxReparcelAdjustment(this);
    } else {
      const config_date = (
        await firestore.collection("config").doc("segunda_via").get()
      ).data().max_days_internal;
      this.maxDateChangeExpire = config_date ?? 15;
      this.installmentMaxDateChangeExpire = defineMaxReparcelAdjustment(this);
    }

    function defineMaxReparcelAdjustment(data) {
      //Determina o máximo de tempo que alguém pode alterar das datas de vencimentos de parcelas
      if (data.reparcelDebtBillingId) {
        due_date = data.getDebtBillingDueDate(data.reparcelDebtBillingId);
      } else if (data.reparcelInstallmentGroupId) {
        const first_debt_billing = data.installmentsGroups.find(
          (ig) => ig.id === data.reparcelInstallmentGroupId,
        ).charged_debt_billings[0];
        due_date = data.getDebtBillingDueDate(first_debt_billing);
      }
      let date = moment.max(new Date(), moment(due_date));
      date = moment(date).toDate();
      date.setDate(date.getDate() + data.maxDateChangeExpire ?? 15);
      return date.toISOString();
    }

    if (this.cards.length === 0) {
      await this.getCardsByUser(this.userCS.cards);
    }

    if (this.cards) {
      this.creditCardsData = this.cards.map((item) => {
        return item.data;
      });
    }
  },
  methods: {
    ...mapActions("installment", [
      "getInstallmentsGroupsByConsumerUnit",
      "getDebtBillingsByConsumerUnit",
    ]),
    ...mapActions("cs", ["getBillings", "getCardsByUser"]),
    ...mapMutations("installment", ["setInstallmentsGroups"]),

    openReparcelDialog(debt_billing, installment_group) {
      this.changeDueDateDialog = true;
      this.reparcelType = debt_billing ? "individual" : "all";
      this.reparcelDebtBillingId = debt_billing;
      this.reparcelInstallmentGroupId = installment_group;
    },
    closeReparcelDialog() {
      this.changeDueDateDialog = false;
      this.reparcelType = "";
      this.reparcelDebtBillingId = "";
      this.newDueDate = "";
      this.reparcelInstallmentGroupId = "";
      this.newDueDate = "";
    },
    async openReprocessingDialog(group) {
      try {
        const debt_billing = await firestore
          .collection("debt_billing")
          .doc(group.charged_debt_billings[0])
          .get();
        const usedCreditCard = await getCards([debt_billing.data().card_hash]);
        this.usedCreditCard = usedCreditCard[0].data;
      } catch (error) {
        this.showSnackBar("Erro ao buscar cartões do membro.", "top", "red");
      }
      this.currentInstallmentGroup = group;
      this.showReprocessingDialog = true;
    },
    async reprocessInstallmentGroup() {
      if (!this.selectedCreditCard) {
        this.showSnackBar(
          "Selecione um cartão de crédito para prosseguir.",
          "top",
          "red",
        );
        return;
      }
      try {
        await firestore
          .collection("installments_group")
          .doc(this.currentInstallmentGroup.id)
          .update({ status: "yet_to_charge" });

        await firestore
          .collection("debt_billing")
          .doc(this.currentInstallmentGroup.charged_debt_billings[0])
          .update({
            card_hash: this.selectedCreditCard.id,
            status: "reprocessing",
          });

        this.showSnackBar(
          "Tentativa de reprocessamento do acordo feita com sucesso.",
          "top",
          "green",
        );
      } catch (error) {
        this.showSnackBar(
          "Erro ao realizar reprocessamento do acordo",
          "top",
          "red",
        );
        console.error(error);
      } finally {
        this.closeReprocessingDialog();
      }
    },
    closeReprocessingDialog() {
      this.currentInstallmentGroup = null;
      this.selectedCreditCard = null;
      this.usedCreditCard = null;
      this.showReprocessingDialog = false;
    },
    openCancellationDialog(group) {
      this.currentInstallmentGroup = group;
      this.showCancellationDialog = true;
    },
    async cancelInstallmentGroup() {
      try {
        await cancel(this.currentInstallmentGroup.id, true);
        this.showSnackBar(
          "Cancelamento do acordo efetuado com sucesso.",
          "top",
          "green",
        );
      } catch (error) {
        this.showSnackBar(
          "Erro ao realizar cancelamento do acordo.",
          "top",
          "red",
        );
        console.error(error);
      } finally {
        this.closeCreditCancellationDialog();
      }
    },
    closeCreditCancellationDialog() {
      this.currentInstallmentGroup = null;
      this.showCancellationDialog = false;
    },
    async reparcel() {
      if (!this.$refs["reparcel"].validate()) {
        return false;
      }
      this.loadingChange = true;
      let reparcelRes = null;
      if (this.reparcelType === "all") {
        reparcelRes = reparcelAll(
          this.reparcelInstallmentGroupId,
          this.newDueDate,
        );
      } else if (this.reparcelType === "individual") {
        reparcelRes = reparcel(this.reparcelDebtBillingId, this.newDueDate);
      }
      await reparcelRes
        .then(() => {
          this.closeReparcelDialog();
          this.loadingChange = false;
          this.showSnackBar(
            "Data de vencimento alterada com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.closeReparcelDialog();
          this.loadingChange = false;
          const msg =
            err.response.data.error.message ?? err.response.data.error;
          this.showSnackBar(
            "Erro ao alterar data de vencimento. " + msg,
            "top",
            "red",
          );
        });
    },
    async simulate(debt_billing_id, newDueDate) {
      const res = await simulateReparcel(debt_billing_id, newDueDate);
      this.newInstallmentValue =
        "R$ " + res.data.new_value.toFixed(2).replace(".", ",");
    },
    getInstallmentStatus(index, group) {
      if (group.charge_type === "debt_billing") {
        if (group.charged_debt_billings) {
          if (index < group.charged_debt_billings.length) {
            if (group.paid_debt_billings) {
              if (
                group.paid_debt_billings.includes(
                  group.charged_debt_billings[index],
                )
              ) {
                return "Paga";
              }
            }
            return "Aberta";
          }
        }
      } else {
        if (group.charged_billings) {
          if (index < group.charged_billings.length) {
            if (group.paid_billings) {
              if (group.paid_billings.includes(group.charged_billings[index])) {
                return "Paga";
              }
            }
            return "Aberta";
          }
        }
      }
      return "A cobrar";
    },
    getInstallmentColor(index, group) {
      let status = this.getInstallmentStatus(index, group);
      if (status == "Paga") {
        return "green lighten-3";
      } else if (status == "Aberta") {
        return "grey lighten-3";
      } else {
        return "white";
      }
    },
    getDebtBillingDueDate(id) {
      if (id) {
        let debt_billing = this.debtBillings.find((e) => e.id == id);
        if (debt_billing) {
          return debt_billing.due_date;
        }
      }
    },
    getDebtBillingTotal(id) {
      if (id) {
        let debt_billing = this.debtBillings.find((e) => e.id == id);
        if (debt_billing) {
          return debt_billing.total;
        }
      }
    },
    getDebtBillingPaidDate(id) {
      if (id) {
        let debt_billing = this.debtBillings.find((e) => e.id == id);
        if (debt_billing && debt_billing.transaction) {
          return moment(debt_billing.transaction.date_updated).format(
            "YYYY-MM-DD",
          );
        }
      }
    },
    gotoTransactionHistory(transaction_id) {
      if (transaction_id) {
        eventBus.$emit("billing_id", transaction_id);
        eventBus.$emit("right", true);
      }
    },
    openBillet(id) {
      if (id) {
        let debt_billing = this.debtBillings.find((e) => e.id == id);
        if (debt_billing) {
          if (debt_billing.pix_url) {
            window.open(debt_billing.pix_url, "_blank");
            return;
          } else if (
            debt_billing.transaction &&
            debt_billing.transaction.boleto_url
          ) {
            window.open(debt_billing.transaction.boleto_url, "_blank");
            return;
          }
        }
      }
    },
    beforeToday(date) {
      if (!date) return;
      let today = new Date();
      today = moment(today).format("YYYY-MM-DD");
      if (today.replaceAll("-", "") > date.replaceAll("-", "")) {
        return true;
      }
    },
    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },
    showData(faturaId) {
      const fatura = this.billings.find((billing) => billing.id == faturaId);
      const formattedTotal =
        "R$ " +
        (
          Number(fatura.total) +
          (fatura.cemig_value_included ? 0 : Number(fatura.total_invoice))
        )
          .toFixed(2)
          .replace(".", ",");
      const splitCompetence = fatura.competence.split("-");
      const formattedCompetence = splitCompetence[1] + "/" + splitCompetence[0];
      return formattedCompetence + " - " + formattedTotal;
    },
    toggleBillingsVisibity(index) {
      const updatedInstallmentGroup = JSON.parse(
        JSON.stringify(this.installmentsGroups),
      );
      updatedInstallmentGroup[index].showBillings =
        !updatedInstallmentGroup[index].showBillings;
      this.setInstallmentsGroups(updatedInstallmentGroup);
    },
    toggleParcelsVisibity(index) {
      const updatedInstallmentGroup = JSON.parse(
        JSON.stringify(this.installmentsGroups),
      );
      updatedInstallmentGroup[index].showParcels =
        !updatedInstallmentGroup[index].showParcels;
      this.setInstallmentsGroups(updatedInstallmentGroup);
    },
    iconBrand(item) {
      if (item?.brand === "visa") return "../../../icons/cards/visa.svg";
      if (item?.brand === "mastercard")
        return "../../../icons/cards/mastercard.svg";
      if (item?.brand === "elo") return "../../../icons/cards/elo.svg";
      else return "../../../icons/cards/unknown.svg";
    },
  },
  filters: {
    formatCurrency(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatChargeType(type) {
      if (type == "debt_billing") {
        return "Cobrança Avulsa";
      } else if (type == "credit_billing") {
        return "Cobrança no Cartão";
      } else {
        return "Cobrança em Faturas";
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  components: {
    cpnDetalhesFatura: DetalhesFatura,
  },
};
</script>

<style scoped lang="scss">
.dialog-container {
  display: flex;
  flex-direction: column;
  max-width: 90%;
  gap: 10px;

  .card-image {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .reprocess-select {
    width: 300px !important;
  }
}
</style>
